import { fhirAPI, getData, putData } from '@/lib/axios';
import { API_BASE_URL, FHIR_API } from '@/constants/api-endpoints.constants';
import storageService from '@/lib/storage-service';
import { Task } from '@/types/recordManagement';
import { QAAuditSummaryRes } from '@/types/recordManagement/audit';

export const documentReferenceAPIs = {
  getQADocsSummaryCount: async (
    subtype?: string
  ): Promise<{ data: QAAuditSummaryRes }> => {
    return fhirAPI.get(
      subtype
        ? `/AuditEvent?_summary=count&subtype=${subtype}`
        : '/AuditEvent?_summary=count'
    );
  },
  getAllValueSet: async (url?: string, text?: string) => {
    try {
      const filter = text ? `&filter=${text}` : '';
      const data = await getData(
        `${API_BASE_URL}/emr/fhir/R4/ValueSet/$expand?url=${url}${filter}`
      );
      return data?.compose?.include[0]?.concept;
    } catch (error) {
      console.error({ error });
    }
  },

  getAllValueSetForTaxonomy: async (url?: string, text?: string) => {
    try {
      const filter = text ? `&filter=${text}` : '';
      const data = await getData(
        `${FHIR_API}/ValueSet/$expand?url=${url}${filter}`
      );
      return data?.expansion?.contains;
    } catch (error) {
      console.error({ error });
    }
  },

  updateTask: async (id?: string | null, payload?: Task) => {
    try {
      await putData(`${API_BASE_URL}/emr/fhir/R4/Task/${id}`, payload, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/fhir+json',
          Authorization: `Bearer ${storageService.getAccessToken()}`,
        },
      });
    } catch (error) {
      console.error({ error });
    }
  },

  getTasks: async (
    count: number,
    sort: string,
    total: string,
    offset?: number,
    practitionerId?: string,
    businessStatus?: string,
    fallbackBusinessStatus?: string
  ) => {
    try {
      const searchParams = new URLSearchParams({
        _count: count.toString(),
        _sort: sort,
        _total: total,
      });

      if (offset !== undefined) {
        searchParams.append('_offset', offset.toString());
      }
      // Need to test this in prod
      // if (practitionerId) {
      //   searchParams.append('owner', `Practitioner/${practitionerId}`);
      // }

      if (businessStatus) {
        searchParams.append('business-status', businessStatus);
      }

      if (fallbackBusinessStatus) {
        searchParams.append('business-status', fallbackBusinessStatus);
      }

      const response = await fhirAPI.get(`/Task?${searchParams.toString()}`);
      const tasks = response?.data?.entry || [];
      const totalTasks = response?.data?.total || 0;
      const uniquePatientIds = [
        ...new Set(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          tasks.map((t: any) => t.resource?.owner?.reference?.split('/')[1])
        ),
      ].filter(Boolean);

      const patientResponses = await Promise.allSettled(
        uniquePatientIds.map((id) => fhirAPI.get(`/Practitioner/${id}`))
      );

      const patientMap = new Map(
        patientResponses
          .filter(res => res.status === 'fulfilled')
          .map(res => {
            const data = res.value.data;
            return [data.id, data];
          })
      );

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const enrichedTasks = tasks.map((entry: any) => {
        const patientId = entry.resource?.owner?.reference?.split('/')[1];

        if (entry.resource?.owner) {
          entry.resource.owner.resource = patientMap.get(patientId) || null;
        }

        return {
          ...entry.resource,
        };
      });
      return {
        tasks: enrichedTasks,
        total: totalTasks,
      };
    } catch (err) {
      console.error({ err });
    }
  },
};
